export const EVENT_NAME_REQUEST = "EVENT_NAME_REQUEST";
export const EVENT_NAME_SUCCESS = "EVENT_NAME_SUCCESS";
export const EVENT_NAME_FAIL = "EVENT_NAME_FAIL";
export const EVENT_NAME_RESET = "EVENT_NAME_RESET";

export const UNIVERSITY_COUNT_REQ = "UNIVERSITY_COUNT_REQ";
export const UNIVERSITY_COUNT_SUCCESS = "UNIVERSITY_COUNT_SUCCESS";
export const UNIVERSITY_COUNT_FAILED = "UNIVERSITY_COUNT_FAILED";

export const UNIVERSITY_ATTENDED_COUNT_REQ = "UNIVERSITY_ATTENDED_COUNT_REQ";
export const UNIVERSITY_ATTENDED_COUNT_SUCCESS =
  "UNIVERSITY_ATTENDED_COUNT_SUCCESS";
export const UNIVERSITY_ATTENDED_COUNT_FAILED =
  "UNIVERSITY_ATTENDED_COUNT_FAILED";

export const UNIVERSITY_COUNT_ATTEMPTED_REQ = "UNIVERSITY_COUNT_ATTEMPTED_REQ";
export const UNIVERSITY_COUNT_ATTEMPTED_SUCCESS =
  "UNIVERSITY_COUNT_ATTEMPTED_SUCCESS";
export const UNIVERSITY_COUNT_ATTEMPTED_FAILED =
  "UNIVERSITY_COUNT_ATTEMPTED_FAILED";
export const UNIVERSITY_COUNT_ATTEMPTED_RESET =
  "UNIVERSITY_COUNT_ATTEMPTED_RESET";

export const RECOMMENDED_UNIVERSITY_REQ = "RECOMMENDED_UNIVERSITY_REQ";
export const RECOMMENDED_UNIVERSITY_SUCCESS = "RECOMMENDED_UNIVERSITY_SUCCESS";
export const RECOMMENDED_UNIVERSITY_FAILED = "RECOMMENDED_UNIVERSITY_FAILED";
export const RECOMMENDED_UNIVERSITY_RESET = "RECOMMENDED_UNIVERSITY_RESET";

export const RECOMMENDED_UNIVERSITY_LIST_REQ =
  "RECOMMENDED_UNIVERSITY_LIST_REQ";
export const RECOMMENDED_UNIVERSITY_LIST_SUCCESS =
  "RECOMMENDED_UNIVERSITY_LIST_SUCCESS";
export const RECOMMENDED_UNIVERSITY_LIST_FAILED =
  "RECOMMENDED_UNIVERSITY_LIST_FAILED";
export const RECOMMENDED_UNIVERSITY_LIST_RESET =
  "RECOMMENDED_UNIVERSITY_LIST_RESET";
